import { SCHEDULER_FILTERS_STORAGE_KEY_PREFIX } from './schedule.consts'
import { StoredSchedulerFilters } from './schedule.types'

// La clé est suffixée par l'id de ferme : changer de ferme repart de zéro (filtres non partagés entre fermes).
const buildKey = (idFerme: string): string => `${SCHEDULER_FILTERS_STORAGE_KEY_PREFIX}.${idFerme}`

/**
 * Lit les filtres mémorisés pour une ferme. Retourne null si rien de valide n'est stocké
 */
export const readSchedulerFilters = (idFerme: string): StoredSchedulerFilters | null => {
	try {
		const raw = window.localStorage.getItem(buildKey(idFerme))
		if (!raw) {
			return null
		}
		const parsed = JSON.parse(raw)
		if (!parsed || !Array.isArray(parsed.selectedRessourceIds)) {
			return null
		}
		return {
			nbDays: typeof parsed.nbDays === 'number' ? parsed.nbDays : 1,
			selectedRessourceIds: parsed.selectedRessourceIds.map(String)
		}
	} catch (e) {
		// On reprend default
		return null
	}
}

/**
 * Mémorise les filtres pour une ferme.
 */
export const writeSchedulerFilters = (idFerme: string, filters: StoredSchedulerFilters): void => {
	try {
		window.localStorage.setItem(buildKey(idFerme), JSON.stringify(filters))
	} catch (e) {
		// On ignore silencieusement
	}
}
